//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import InlineSpinner from '../../common/InlineSpinner.vue';

export default {
  name: 'coupon-input',
  data() {
    return {
      response: null,
      error: null,
      isValid: false,
      checkingCoupon: false,
    };
  },
  props: {
    disabled: {
      type: Boolean,
      required: true,
    },
    value: {
      type: String,
    },
    valid: {
      type: Boolean,
    },
  },
  methods: {
    ...mapActions([
      'getCoupon',
    ]),
    updateCouponCode(value) {
      this.$emit('input', value);
    },
    async validateCoupon() {
      if (!this.value || this.value.length === 0) {
        return;
      }

      this.error = null;
      this.checkingCoupon = true;
      this.response = '';
      try {
        const response = (await this.getCoupon(this.value)).data;
        this.isValid = response.valid;
        if (response.valid) {
          this.response = response.description || response.name;
        } else {
          this.error = response.reason || 'Invalid coupon';
        }
        this.$emit('update:valid', this.isValid);
        this.checkingCoupon = false;
      } catch (e) {
        if (e.response && e.response.status === 404) {
          this.error = e.response.data;
          this.checkingCoupon = false;
          this.$emit('update:valid', false);
        } else {
          throw e;
        }
      }
    },
  },
  computed: {
    buttonIsDisabled() {
      return this.checkingCoupon || this.disabled
        || this.value === null || this.value.length === 0;
    },
    inputIsDisabled() {
      return this.checkingCoupon
        || this.disabled
        || this.isValid;
    },
  },
  components: {
    InlineSpinner,
  },
};
